import React, { useEffect, useState } from "react";
import { t } from "../i18n/index.js";

type BackTarget = {
  to: string;
  label: string;
};

function resolveBackTarget(pathname: string): BackTarget | null {
  const label = t.sidebarHomeLink.back;
  if (pathname === "/llm-api" || pathname.startsWith("/llm-api/")) {
    return { to: "/llm-introduction", label };
  }
  if (pathname === "/api" || pathname.startsWith("/api/")) {
    return { to: "/quick-start", label };
  }
  return null;
}

export function SidebarHomeLink() {
  const [pathname, setPathname] = useState<string | null>(null);

  useEffect(() => {
    const read = () => setPathname(window.location.pathname);
    read();
    window.addEventListener("popstate", read);
    const origPush = history.pushState;
    const origReplace = history.replaceState;
    history.pushState = function (...args) {
      const ret = origPush.apply(this, args);
      read();
      return ret;
    };
    history.replaceState = function (...args) {
      const ret = origReplace.apply(this, args);
      read();
      return ret;
    };
    return () => {
      window.removeEventListener("popstate", read);
      history.pushState = origPush;
      history.replaceState = origReplace;
    };
  }, []);

  if (pathname === null) return null;
  const target = resolveBackTarget(pathname);
  if (!target) return null;

  return (
    <a
      href={target.to}
      style={{
        display: "inline-flex",
        alignItems: "center",
        gap: "6px",
        padding: "6px 10px",
        margin: "0 0 8px",
        fontSize: "12px",
        fontWeight: 500,
        color: "var(--muted-foreground)",
        background: "transparent",
        borderRadius: "calc(var(--radius) - 4px)",
        textDecoration: "none",
        transition: "color 150ms ease, background 150ms ease",
        alignSelf: "flex-start",
      }}
      onMouseEnter={(e) => {
        e.currentTarget.style.color = "var(--foreground)";
        e.currentTarget.style.background = "var(--muted)";
      }}
      onMouseLeave={(e) => {
        e.currentTarget.style.color = "var(--muted-foreground)";
        e.currentTarget.style.background = "transparent";
      }}
    >
      <svg
        width="13"
        height="13"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        <path d="M19 12H5M12 19l-7-7 7-7" />
      </svg>
      {target.label}
    </a>
  );
}
